import { Modal } from 'bootstrap';
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import uuid from 'react-uuid';
import TapSelect from '../../../components/ui/TapSelect';
import HttpAPICall from '../../../services/HttpAPICall';
import { toast } from 'react-toastify';
import TapIcon from '../../../services/TapIcon';
import { IAM_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import Loader from '../../../components/ui/Loader/Loader';

function ChangeHirerachyLevel({ userDetailData, onRefresh, escalationData }, ref) {
    const modalId                           = uuid();
    const modalElementRef                   = useRef();
    const modalRef                          = useRef();
    const accessToken                       = useSelector(state => state.auth.access_token);
    const [formData, setFormData]           = useState({
                                                    escalation_level_ids: [],
                                                    user_id: "",
                                                   });
    const [allLevels, setAllLevels]         = useState([]);
    const [loading, setLoading]             = useState(false);
    const [formLoading, setFormLoading]     = useState(false);
    const [levelsLoaded, setLevelsLoaded]   = useState(false);

    useImperativeHandle(ref, () => ({
        initModalHandler: () => {
            openModal();
        }
    }));

    useEffect(() => {
        modalElementRef.current = document.getElementById(modalId);
        modalRef.current = new Modal(modalElementRef.current, { keyboard: false, backdrop: false });
        return () => {
            if (modalRef.current) {
                modalRef.current.dispose();
            }
        };
    }, []);

    const initialFormData = () => {
        if (levelsLoaded) {
            return;
        }
        setFormLoading(true);
        HttpAPICall.withAthorization('GET', IAM_API_BASE_URL_2 + '/escalation_level_form_data', accessToken, {}, {}, (resp) => {
            const transformedLevels = resp.data.map(level => ({
                value: level.id,
                label: level.name
            }));
            setAllLevels(transformedLevels);
            setLevelsLoaded(true);

            if (escalationData) {
                const currentLevelIds = escalationData.map(level => level.id);
                setFormData(prev => ({
                    ...prev,
                    escalation_level_ids: currentLevelIds,
                    user_id: userDetailData?.enc_id
                }));
            }
        }).then(() => {
            setFormLoading(false);
        }).catch((error) => {
            toast.error(error?.msg, { position: toast.POSITION.TOP_RIGHT });
            setFormLoading(false);
        });
    };

    const openModal = () => {
        if (modalRef.current) {
            modalRef.current.show();
            initialFormData();
        }
    };

    const closeModal = () => {
        if (modalRef.current) {
            modalRef.current.hide();
        }
    };

    const handleLevelSelect = (selectedOption) => {
        setFormData({
            ...formData,
            escalation_level_ids: selectedOption ? selectedOption.map(option => option.value) : []
        });
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        setLoading(true);
        const payload = {
            user_id: formData.user_id,
            escalation_level_ids: formData.escalation_level_ids
        };

        HttpAPICall.withAthorization('PUT', IAM_API_BASE_URL_2 + '/escalation_level_update', accessToken, {}, payload, (resp) => {
            toast.success(resp.data.msg, { position: toast.POSITION.TOP_RIGHT });
            if (onRefresh) {
                onRefresh();
            }
            closeModal();
        }).then(() => {
            setLoading(false);
        }).catch((error) => {
            toast.error(error.response?.data?.message, { position: toast.POSITION.TOP_RIGHT });
            setLoading(false);
        });
    };

    return (
        <div className="modal fade" id={modalId} ref={modalElementRef} tabIndex="-1">
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Change Escalation Hierarchy Level</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        <form className="bg-white" onSubmit={handleSubmit} id={`${modalId}Form`}>
                            {formLoading ? <Loader /> : (
                                <>
                                    <table className="table table-hover table-borderless bg-white my-2 mx-2">
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "20%" }}>Name</td>
                                                <th style={{ width: "45%" }}>{userDetailData?.full_name || "-"}</th>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "20%" }}>Role</td>
                                                <th>{userDetailData?.role?.role || "-"}</th>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "25%" }}>Escalation Levels</td>
                                                <th>
                                                    {escalationData?.length > 0
                                                        ? escalationData.map(level => level.name).join(', ')
                                                        : "-"}
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div className="row mb-3 mx-2 ">
                                        <label className="col-sm-4 col-form-label mb-3">Levels</label>
                                        <div className="col-sm-7 align-items-center mb-3 ms-2">
                                            <TapSelect
                                                options={allLevels}
                                                changeEvent={handleLevelSelect}
                                                isSearchable={true}
                                                isClearable={true}
                                                placeholder="Select Levels"
                                                isMulti={true}
                                                value={allLevels.filter(level =>
                                                    formData.escalation_level_ids.includes(level.value)
                                                )}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}
                        </form>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={closeModal} disabled={loading}>
                            Cancel
                        </button>
                        <button className="btn btn-primary" type="submit" form={`${modalId}Form`} disabled={loading || formLoading}>
                            Update
                            {loading && (<TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin ms-2" />)}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default forwardRef(ChangeHirerachyLevel);